import { baseApi } from "./base.api";

export const blogCategoriesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBlogCategories: build.query({
      query: (params) => ({ url: "/blog/categories/fetch", method: "GET", params }),
      providesTags: ["BlogCategory"],
    }),
    fetchBlogCategoriesAll: build.query({
      query: () => ({ url: "/blog/categories/fetch/all", method: "GET" }),
      providesTags: ["BlogCategory"],
    }),
    fetchTrashedBlogCategories: build.query({
      query: (params) => ({ url: "/blog/categories/fetch/trashed", method: "GET", params }),
      providesTags: ["BlogCategory"],
    }),
    fetchBlogCategoryById: build.query({
      query: (id) => ({ url: `/blog/categories/fetch/${id}`, method: "GET" }),
      providesTags: ["BlogCategory"],
    }),
    createBlogCategory: build.mutation({
      query: (body) => ({ url: "/blog/categories/create", method: "POST", body }),
      invalidatesTags: ["BlogCategory"],
    }),
    updateBlogCategory: build.mutation({
      query: ({ id, body }) => ({ url: `/blog/categories/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["BlogCategory"],
    }),
    changeBlogCategoryStatus: build.mutation({
      query: (id) => ({ url: `/blog/categories/status/${id}`, method: "PUT" }),
      invalidatesTags: ["BlogCategory"],
    }),
    restoreBlogCategory: build.mutation({
      query: (id) => ({ url: `/blog/categories/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["BlogCategory"],
    }),
    bulkRestoreBlogCategories: build.mutation({
      query: (body) => ({ url: "/blog/categories/bulk-restore", method: "POST", body }),
      invalidatesTags: ["BlogCategory"],
    }),
    deleteBlogCategory: build.mutation({
      query: (id) => ({ url: `/blog/categories/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["BlogCategory"],
    }),
    bulkDeleteBlogCategories: build.mutation({
      query: (body) => ({ url: "/blog/categories/bulk-delete", method: "POST", body }),
      invalidatesTags: ["BlogCategory"],
    }),
    destroyBlogCategory: build.mutation({
      query: (id) => ({ url: `/blog/categories/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["BlogCategory"],
    }),
    bulkDestroyBlogCategories: build.mutation({
      query: (body) => ({ url: "/blog/categories/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["BlogCategory"],
    }),
  }),
});

export const {
  useFetchBlogCategoriesQuery,
  useFetchBlogCategoriesAllQuery,
  useFetchTrashedBlogCategoriesQuery,
  useFetchBlogCategoryByIdQuery,
  useCreateBlogCategoryMutation,
  useUpdateBlogCategoryMutation,
  useChangeBlogCategoryStatusMutation,
  useRestoreBlogCategoryMutation,
  useBulkRestoreBlogCategoriesMutation,
  useDeleteBlogCategoryMutation,
  useBulkDeleteBlogCategoriesMutation,
  useDestroyBlogCategoryMutation,
  useBulkDestroyBlogCategoriesMutation,
} = blogCategoriesApi;
